import classNames from "classnames"
import { findTailwindBorderColorFromHex } from "web/components/Charts/chart-util"

export function ChartTooltip({
  payload,
  label,
  chartKind,
  formatter,
  valueLabels,
}) {
  if (!payload || payload.length === 0) return null

  const hasValueLabels = valueLabels !== undefined
  const hasMultiplePayloads = payload.length > 1

  function getHoveredItemHexColor() {
    if (payload[0].hasOwnProperty("fill")) {
      return payload[0].fill
    } else {
      return payload[0].payload.fill
    }
  }

  const borderColor = findTailwindBorderColorFromHex(getHoveredItemHexColor())
  const showPercentage = chartKind === "pie"

  return (
    <div className="bg-white p-2 opacity-100 shadow-altrio-2">
      <div className={classNames("border-l-4 pl-2", borderColor)}>
        <label className="text-xs font-bold text-neutral-6">
          {label || payload[0].name}
        </label>
        <div className="pb-1">
          {payload.map((el) => {
            const valueLabel = hasValueLabels
              ? valueLabels[el.name]
              : el.payload.name

            return (
              <div key={el.name} className="mt-2 text-xs text-neutral-4">
                {`${
                  hasMultiplePayloads || hasValueLabels ? `${valueLabel}: ` : ""
                }${
                  formatter === undefined
                    ? el.payload[el.dataKey]
                    : formatter(el.payload[el.dataKey])
                }`}
                {showPercentage && <span> ({el.payload.percent_value}%)</span>}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default function tooltip({ formatter, chartKind, valueLabels }) {
  return (props) => (
    <ChartTooltip
      {...props}
      formatter={formatter}
      chartKind={chartKind}
      valueLabels={valueLabels}
    />
  )
}
